import api from './client';

export const getUsage = () =>
  api.get('/ai-billing/usage').then(r => r.data);

export const getUsageDetailed = () =>
  api.get('/ai-billing/usage/detailed').then(r => r.data);

export const getPlans = () =>
  api.get('/ai-billing/plans').then(r => r.data);

export const upgradePlan = (planName) =>
  api.post('/ai-billing/upgrade', { planName }).then(r => r.data);

export const getBillingHistory = (page = 1) =>
  api.get('/ai-billing/history', { params: { page } }).then(r => r.data);
